import { ANALYTICS_EVENTS, FRAME_THEME_COLOR } from '@nandosaus/constants';
import PropTypes from 'prop-types';

import { withAppProps } from '@utils/with-app-props';
import { analytics } from '../../analytics';
import { BackgroundFrame } from '../../components/frames/background-frame';
import { Col, Container, Row } from '../../components/grid';
import { CreateAccountForm } from '../../components/create-account-form';
import { Layout } from '../../components/layout';
import { Link } from '../../components/link';
import { navigation } from '../../constants';
import { P } from '../../components/typography';
import { useRedirectIfAuthenticated } from '../../hooks/useRedirectIfAuthenticated';

const CreateAccount = ({ title }) => {
  useRedirectIfAuthenticated();

  const { TEAL } = FRAME_THEME_COLOR;

  return (
    <Layout title={title}>
      <BackgroundFrame showFireIcon showTopBar={false} variant={TEAL}>
        <Container>
          <Row mt={4} mb={3}>
            <Col width={{ xs: 12 / 12, lg: 6 / 12 }} offset={[0, 0, 0, 3 / 12]}>
              <CreateAccountForm />
              <P variant={3} textAlign="center" mt={1}>
                Already a member?{' '}
                <Link
                  variant={3}
                  href={navigation.SIGN_IN}
                  onClick={() => analytics.track(ANALYTICS_EVENTS.USER_SIGN_IN_CLICKED, { location: 'Sign Up' })}
                >
                  Sign in
                </Link>
              </P>
            </Col>
          </Row>
        </Container>
      </BackgroundFrame>
    </Layout>
  );
};

CreateAccount.propTypes = {
  title: PropTypes.string,
};

CreateAccount.defaultProps = {
  title: undefined,
};

export const getStaticProps = withAppProps(async () => {
  return {
    props: {
      title: 'Create Account',
    },
  };
});

export default CreateAccount;
